<template>
  <div>
    <div
      v-for="n in 5"
      :key="n"
      class="flex justify-between items-center py-4"
      :class="{ 'border-b border-gray-200': n < 5 }"
    >
      <div class="w-3/5">
        <div class="mb-2">
          <Skeletor height="20px" width="50%" />
        </div>
        <div>
          <Skeletor height="16px" width="75%" />
        </div>
      </div>

      <div class="w-1/5 flex justify-center">
        <Skeletor height="20px" width="70px" />
      </div>

      <div class="w-1/5 flex justify-end">
        <Skeletor height="40px" width="90px" class="rounded-md" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    // Skeletor
  },
}
</script>

<style scoped>
/* Можно добавить анимацию для скелетонов, если ее нет глобально */
.skeleton-container > * {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
</style>
